import { CheckoutEventFailure } from '../../models/checkout/checkout-event-failure.interface';

export const mockCheckoutEventFailure: CheckoutEventFailure = {
  transactionId: '123456', // optional
  status: 'error',
  eventDescription: 'Checkout failed',
  ...new CustomEvent('checkout-event-partial-failure', {
    detail: {
      transactionId: '123456', // optional
      status: 'error',
      eventDescription: 'Checkout failed',
    },
  }),
};
